import styled from '@emotion/styled';
import Input from '__components/Kizen/Input';

export const Range = styled.input<{ thumbWidth: number }>`
  -webkit-appearance: none;
  overflow: hidden;
  border-radius: 8px;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    background-color: var(--color-background-white);
    border: 1px solid var(--color-button-secondary-default);
    height: ${({ thumbWidth }) => thumbWidth}px;
    width: ${({ thumbWidth }) => thumbWidth}px;
    border-radius: 100%;
    box-shadow: -430px 0 0 423px var(--color-button-secondary-default);
  }

  &::-webkit-slider-runnable-track {
    background-color: var(--color-border-medium-light);
  }
`;

export const TranslatedHeader = styled.div`
  transform: translateY(-100%);
`;

export const Dots = styled.div`
  position: relative;
  height: 2px;
  overflow: hidden;

  &:after {
    content: '.....................................................................................................................................................................................................................';
    letter-spacing: 1px;
    position: absolute;
    width: 100%;
    overflow: hidden;
    top: -6px;
  }
`;

export const SmallInput = styled(Input)`
  & input {
    width: 100%;
  }
`;
